export const Sse = {
  category: {
    attendance: 1,
  },
};
